import { PageHeader } from '@fukuri-admins/ui/common';

type Props = {
  fullName: string;
  indexHref: string;
};

export const EditClientAdminUserFormHeaderPresentation: React.FC<Props> = ({
  fullName,
  indexHref,
}) => (
  <PageHeader
    variant='breadcrumb'
    breadcrumbItems={[{ label: '企業管理者', href: indexHref }, { label: `${fullName}の編集` }]}
  />
);
